import styled from 'styled-components';

import {
  colorBlack900,
  colorGrayLighten300,
  colorLink400,
  colorWhite,
  fontFamilyPrimary,
  HoverState,
} from '@/styleUtils';

import { StaticContentTitle } from '../StaticContent.styles';

export const ContactsUs = styled.div`
  grid-area: contactUs;
  background-color: ${colorWhite};
  margin: 16px 0 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  text-align: center;
  border-radius: 12px;
`;
export const ContactsBlock = styled.div`
  display: flex;
  flex-direction: column;
  grid-area: text;
`;
export const AboutSectionTitle = styled.h4`
  display: flex;
  font: 400 14px/24px ${fontFamilyPrimary};
  color: ${colorBlack900};
`;
export const Mail = styled.a`
  font: 400 14px/24px ${fontFamilyPrimary};
  color: ${colorLink400};
  ${HoverState};
`;
export const StyledImg = styled.img`
  width: 93px;
  height: 72px;
  grid-area: img;
`;
export const StyledTitle = styled(StaticContentTitle)`
  grid-area: title;
`;

export const ContactsWrapper = styled.div`
  display: grid;
  grid-template-areas:
    'title title'
    'img text';
  justify-content: center;
  align-items: center;
  gap: 16px;
  border-radius: 8px;
  background-color: ${colorGrayLighten300};
  padding: 24px;
`;
